import {NgModule, NO_ERRORS_SCHEMA} from '@angular/core';
import {RouterModule} from '@angular/router';
import {SharedModule} from '../shared/shared.module';
import {
  AdminEditFormComponent,
  AdminListComponent,
  AdminSearchComponent,
  AdminSearchFormComponent,
  AdminSearchLabelsComponent,
} from './components';
import {AuthGuardService} from '../../core/services';
import {AdminsComponent} from './pages/users/admins.component';

@NgModule({
  schemas: [NO_ERRORS_SCHEMA],
  imports: [
    SharedModule,
    RouterModule.forRoot([
      {
        path: 'admins',
        component: AdminsComponent,
        canActivate: [AuthGuardService],
        data: {
          breadcrumb: 'Admins',
          roles: ['ADMIN_VIEW']
        },
      },
    ]),
  ],
  declarations: [
    AdminsComponent,
    AdminSearchComponent,
    AdminSearchFormComponent,
    AdminListComponent,
    AdminSearchLabelsComponent,
    AdminEditFormComponent,
  ],
})
export class AdminsModule {}
